import I18n from 'app/i18n';
import csrfToken from 'app/helpers/csrf-token';
import {configStore} from 'app/store/global';
import {locationQuery} from 'app/utils/navigate/location';
import {toastError} from 'app/components/toasts/liteToast';
import logEvent from 'app/amplitude/log_event';
import {pushAnalyticsEvent} from 'app/utils/analytics';

const GOOGLE_AUTH_PATH = '/auth/google_oauth2';

interface StartGoogleAuthFlowOptions {
    redirectUrl?: string;
    promocode?: string;
    target?: string;
}

export const startGoogleAuthFlow = ({
    redirectUrl,
    promocode,
    target = '_top'
}: StartGoogleAuthFlowOptions = {}): void => {
    const form = document.createElement('form');

    form.method = 'post';
    form.action = GOOGLE_AUTH_PATH;
    form.target = target;

    const fields: Record<string, string> = {
        authenticity_token: csrfToken() || '',
        site_lang: configStore.CONFIG?.lang || 'en'
    };

    if (redirectUrl) {
        fields.redirect_url = redirectUrl;
    }

    if (promocode) {
        fields.promocode = promocode;
    }

    Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input');

        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    form.remove();
};

const ERROR_KEYS = [
    'google_id_required',
    'email_required',
    'google_already_linked',
    'email_already_registered',
    'failed_to_authenticate',
    'google_unavailable'
];

export const googleErrorMessage = (key: string): string => {
    if (ERROR_KEYS.includes(key)) {
        return I18n.t(`google.errors.${key}`);
    }

    return I18n.t('google.errors.failed_to_authenticate');
};

export const showGoogleAuthError = (): void => {
    const params = locationQuery();
    const errorKey = params.google_auth_error;

    if (!errorKey) {
        return;
    }

    const url = new URL(window.location.href);

    url.searchParams.delete('google_auth_error');
    window.history.replaceState({}, '', url.toString());

    toastError(googleErrorMessage(errorKey));
};

export const showGoogleRegistrationSuccess = (): void => {
    const params = locationQuery();

    if (!params.google_registration) {
        return;
    }

    const url = new URL(window.location.href);

    url.searchParams.delete('google_registration');
    window.history.replaceState({}, '', url.toString());

    logEvent('REGISTRATION_FORM_SENT', {method: 'google'});
    pushAnalyticsEvent('registration_complete', {
        method: 'google',
        placement: 'registration_popup'
    });
};
